import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useTextUnderline } from '../hooks/useTextUnderline';

export default function PolicyLayout({ title, badgeIcon, badgeLabel, heroTitle, heroSubtitle, tocItems, children, version = '1.0', lastUpdated = 'October 15, 2025' }) {
  const [activeToc, setActiveToc] = useState(tocItems[0]?.href || '');
  useTextUnderline();

  useEffect(() => {
    const sections = document.querySelectorAll('.policy-section[id]');
    const tocObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveToc('#' + entry.target.id);
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    sections.forEach(s => tocObserver.observe(s));

    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.05 });
    sections.forEach(s => revealObserver.observe(s));

    return () => { tocObserver.disconnect(); revealObserver.disconnect(); };
  }, []);

  return (
    <>
      <Navbar />

      <section className="policy-hero">
        <div className="policy-hero-inner">
          <div>
            <div className="policy-hero-badge">
              {badgeIcon}
              {badgeLabel}
            </div>
            <h1 dangerouslySetInnerHTML={{ __html: heroTitle }} />
            <p style={{ fontSize: '1rem', lineHeight: 1.8, color: 'var(--text-dark)', opacity: 0.85, maxWidth: 660 }}>
              {heroSubtitle}
            </p>
            <div className="policy-hero-meta">
              <div className="policy-hero-meta-item"><span className="label">Version</span><span className="value">{version}</span></div>
              <div className="policy-hero-meta-item"><span className="label">Last Updated</span><span className="value">{lastUpdated}</span></div>
              <div className="policy-hero-meta-item"><span className="label">Jurisdiction</span><span className="value">Afghanistan</span></div>
            </div>
          </div>
          <div className="policy-hero-visual">
            <div className="img-placeholder">
              <img src={`/images/${title === 'privacy' ? 'pp_icon.png' : 'tos_icon.png'}`} alt={`${title} icon`} />
            </div>
          </div>
        </div>
      </section>

      <div className="policy-layout">
        <aside className="policy-toc">
          <p className="toc-label">On this page</p>
          <ul className="toc-list">
            {tocItems.map(item => (
              <li key={item.href}>
                <a href={item.href} className={activeToc === item.href ? 'toc-active' : ''}>{item.label}</a>
              </li>
            ))}
          </ul>
        </aside>

        <main className="policy-content">
          {children}
        </main>
      </div>

      <Footer />
    </>
  );
}
